<template>
  <div>
    <!-- <h3>Saved Items:</h3> -->
    <ul>
      <li v-for="(item, index) in savedItems" :key="index" class="item">
        <!-- Display saved queries -->
        <div v-if="item.type === 'query'">
          {{ item.date }}
          <span v-if="item.preset === 'search'">Search: {{ item.searchItem }}</span>
          <span v-else-if="item.preset === 'report'">Report on: {{ item.subject }}</span>
        </div>
        <!-- Display saved images -->
        <div v-if="item.type === 'image'">
          <img :src="item.url" alt="Saved Image" class="saved-image"/>
          <div>{{ item.prompt }}</div>
        </div>
        <div class="item-actions">
          <v-btn class="btn" @click="$emit('edit-item', index)">Edit</v-btn>
          <v-btn class="btn" @click="$emit('delete-item', index)">Delete</v-btn>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    savedItems: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style>
/* Add styling for saved images and the rest of the component */
.saved-image {
  width: 100px; /* Example size */
  height: auto;
}
ul {
  list-style-type: none;
  padding: 0;
}

.query-item {
  margin-bottom: 10px;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 5px;
}

.query-date {
  font-weight: bold;
}

.query-actions {
  margin-top: 10px;
}

.btn-edit, .btn-delete {
  cursor: pointer;
  padding: 5px 10px;
  margin-right: 5px;
  border: none;
  border-radius: 3px;
  background-color: #007bff;
  color: white;
}

.btn-delete {
  background-color: #dc3545;
}

/* Add any additional styling as needed */
</style>
